import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgInfo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14 2.625A11.375 11.375 0 1 0 25.375 14 11.387 11.387 0 0 0 14 2.625Zm0 21A9.625 9.625 0 1 1 23.625 14 9.636 9.636 0 0 1 14 23.625Zm1.75-4.375a.875.875 0 0 1-.875.875 1.75 1.75 0 0 1-1.75-1.75V14a.875.875 0 1 1 0-1.75 1.75 1.75 0 0 1 1.75 1.75v4.375a.875.875 0 0 1 .875.875Zm-3.5-10.063a1.313 1.313 0 1 1 2.625 0 1.313 1.313 0 0 1-2.625 0Z" />
  </svg>
);
export default SvgInfo;
